var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.payment_method.color,"small":""},domProps:{"textContent":_vm._s(_vm.payment_method.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }